"use client"

import styled from "@emotion/styled"
import { IconButton } from "@mui/material"
import { useLocale } from "next-intl"
import Image from "next/image"
import { LeftArrow, RightArrow, XIcon } from "ui"
import { getUmbracoMediaUrl } from "utils"
import {
  StyledCloseDiv,
  StyledContainer,
  StyledGalleryPopup,
  StyledImagesDiv,
  StyledMainImage,
  StyledSlideDiv,
  StyledThumbImages,
} from "../ApartmentsForRent/ApartmentGallery"

import { useRef, useState } from "react"
import "swiper/css"
import "swiper/css/navigation"
import { Navigation } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"

const StyledIconButton = styled(IconButton)`
  background-color: white !important;
  width: 20px !important;
  height: 20px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  ${(props) => props.theme.breakpoints.up("md")} {
    width: 40px !important;
    height: 40px !important;
  }
  &:disabled {
    background-color: gray !important;
  }
  &:hover {
    background-color: white !important;
  }
`

const StyledGalleryPopupLocal = styled(StyledGalleryPopup)`
  top: 0 !important;
`

type Props = {
  activeGallery: string[]
  // eslint-disable-next-line no-unused-vars
  setIsOpen: (_isOpen: boolean) => void
}

const SliderExpand = ({ activeGallery, setIsOpen }: Props) => {
  const locale = useLocale()
  const [activeIndex, setActiveIndex] = useState<number>(0)
  const swiperRef = useRef<any>(null)

  const updateSwiperSlide = (index: number) => {
    setActiveIndex(index)
    if (swiperRef.current) {
      swiperRef.current.slideTo(index)
    }
  }
  return (
    <StyledGalleryPopupLocal>
      <StyledContainer>
        <StyledCloseDiv>
          <IconButton onClick={() => setIsOpen(false)}>
            <XIcon />
          </IconButton>
        </StyledCloseDiv>
        <StyledImagesDiv>
          <StyledMainImage heightMargin={350}>
            <Image
              src={getUmbracoMediaUrl(activeGallery?.[activeIndex])}
              layout="fill"
              style={{ objectFit: "cover" }}
              alt="poster"
            />
          </StyledMainImage>
          <StyledThumbImages>
            <StyledIconButton
              onClick={() => updateSwiperSlide(activeIndex - 1)}
              disabled={activeIndex === 0}
            >
              {locale === "en" ? <LeftArrow /> : <RightArrow />}
            </StyledIconButton>
            <Swiper
              onSwiper={(swiper) => (swiperRef.current = swiper)} // Capture the Swiper instance
              navigation={{
                nextEl: `.arrow-left`,
                prevEl: `.arrow-right`,
              }}
              hashNavigation
              modules={[Navigation]}
              slidesPerView={2.2}
              breakpoints={{
                960: {
                  slidesPerView: 4.5,
                },
              }}
              style={{ paddingTop: 0, paddingBottom: 0 }}
              spaceBetween={"16px"}
            >
              {activeGallery.map((image, index) => (
                <SwiperSlide
                  key={index}
                  style={{ cursor: "pointer" }}
                  onClick={() => updateSwiperSlide(index)}
                >
                  <StyledSlideDiv $active={index === activeIndex}>
                    <Image
                      key={index}
                      src={getUmbracoMediaUrl(image)}
                      layout="fill"
                      style={{ objectFit: "cover" }}
                      alt={`poster ${index}`}
                    />
                  </StyledSlideDiv>
                </SwiperSlide>
              ))}
            </Swiper>
            <StyledIconButton
              onClick={() => updateSwiperSlide(activeIndex + 1)}
              disabled={activeIndex === activeGallery.length - 1}
            >
              {locale === "en" ? <RightArrow /> : <LeftArrow />}
            </StyledIconButton>
          </StyledThumbImages>
        </StyledImagesDiv>
      </StyledContainer>
    </StyledGalleryPopupLocal>
  )
}
export default SliderExpand
